import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';
import { ReducerInfo } from 'ia-react-core/~/interfaces/ReducerInfo';
import get from '../../../utils/accessors/get';
import set from '../../../utils/accessors/set';
import merge from '../../../utils/accessors/merge';
import resolveScope from '../../../utils/redux/#resolveScope';
import exposeChangedState from './exposeChangedState';

export default function reduceNamespace<State extends object>(state: State, action: CoreAction, reducerStore: ReducerInfo<any, {}>[], changes: string[]) {
  const updatedState = reducerStore.reduce((latestState, scopedReducerInfo) => {
    const {
      key: currentKey,
      scope: currentScope = [],
      reducer: currentReducer,
      initialState: currentInitialState,
      idName,
    } = scopedReducerInfo;

    const statePath = resolveScope(currentKey, currentScope);
    const statePathArray = statePath.split('.');
    const scopedState: object = get(latestState, statePath);
    const scopedInitState = resolveinitialState(scopedState, currentInitialState, idName);
    const newScopedState = currentReducer(scopedInitState, action);

    if (scopedState !== newScopedState) {
      exposeChangedState(newScopedState, statePathArray, changes);
    }

    return set(latestState, statePath, newScopedState);
  }, state);

  return updatedState;
}

function resolveinitialState(scopedState: object, currentInitialState: object, idName: string) {
  if (typeof scopedState !== 'undefined') {
    // When 2 reducers using the same name are re-registered, we have to update the ids
    if ((idName && get(scopedState, idName) !== get(currentInitialState, idName))) {
      return merge(scopedState, {
        [idName]: get(currentInitialState, idName),
        '[selectors]': get(currentInitialState, '[selectors]'),
        '[actions]': get(currentInitialState, '[actions]'),
      });
    }

    return scopedState;
  }

  return currentInitialState;
}
